import { useStoreDialog } from "../state/useStoreDialogs";
import DialogHeader from "./DialogHeader";

export default function Query() {
  const navTo = useStoreDialog((state) => state.navTo);
  const goHome = useStoreDialog((state) => state.goHome);
  const editMode = false;
  return (
    <div className="h-full w-full bg-red-400">
      <DialogHeader
        title={editMode ? "Edit Query" : "Query"}
        onBack={goHome}
        editMode={editMode}
      />
      <span>Hello add Query sutff plz</span>
    </div>
  );
}
